<div class="investments-table-container">
  <app-grid-table
    [data]="rows()"
    [columns]="columns"
    [title]="titleKey() | translate"
    [loading]="loading()"
    [showSearch]="showSearch()"
  />
</div>
